import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
import { Capacitor } from '@capacitor/core';
import { ModalController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AlertsComponent } from 'src/app/components/alerts/alerts.component';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { RequestsService } from '../requests.service';
import { ToasterComponent } from '../toaster/toaster.component';
import { ModalComponent } from 'src/app/components/modals/modal.component';
import { UserService } from '../User.service';
import { ModalModule } from 'src/app/components/modals/modal.module';

@Component({
  selector: 'app-qrscanner',
  templateUrl: './qrscanner.component.html',
  styleUrls: ['./qrscanner.component.scss'],
})
export class QrscannerComponent implements OnInit {
  result = null;

  constructor(private toaster: ToasterComponent,
    private translate: TranslateService, private request: RequestsService, private navCtrl: NavController,
    private loader: LoaderComponent, private user: UserService,
    private alert: AlertsComponent, private modalController: ModalController) { }

  ngOnInit() {
    if (Capacitor.isNativePlatform()) {
      BarcodeScanner.prepare();
    }
  }

  // async test() {
  //   document.body.classList.remove('qrscanner');
  //   const message = await this.translate.get('charging').toPromise();
  //   await this.loader.presentLoading(message + '...');
  //   this.request.checkQrcode('7c2a4b70-7353-4ff9-ae10-fe84c6916a3c')
  //     .then(async (response) => {
  //       await this.loader.dismiss();
  //       const modal = await this.modalController.create({
  //         component: ModalComponent,
  //         cssClass: 'vinyl-page',
  //         componentProps: {qrcode: '7c2a4b70-7353-4ff9-ae10-fe84c6916a3c', ...response},
  //       });

  //       await modal.present();

  //     })
  //     .catch(async (_) => {
  //       await this.loader.dismiss();
  //       this.toaster.errorToast('vinyl_already_used');
  //     });
  // }

  async startScanner() {
    const guestUser = await this.user.getGuestUser();

    // if (Capacitor.getPlatform() === 'ios') {
    //   this.test();
    // }

    if (!guestUser) {
      const allowed = await this.checkPermission();

      if (allowed) {
        document.body.classList.add('qrscanner');
        await BarcodeScanner.hideBackground(); // make background of WebView transparent
        const result = await BarcodeScanner.startScan();

        if (result.hasContent) {
          const url = new URL(result.content);
          const params = new URLSearchParams(url.search);

          if (params.has('code')) {
            document.body.classList.remove('qrscanner');
            const message = await this.translate.get('charging').toPromise();
            await this.loader.presentLoading(message + '...');
            this.request.checkQrcode(params.get('code'))
              .then(async (response) => {
                await this.loader.dismiss();
                const modal = await this.modalController.create({
                  component: ModalComponent,
                  cssClass: 'vinyl-page',
                  componentProps: {qrcode: params.get('code'), ...response},
                });

                await modal.present();

              })
              .catch(async (_) => {
                await this.loader.dismiss();
                this.toaster.errorToast('vinyl_already_used');
              });
          } else {
            this.toaster.errorToast('error_code_qrcode');
            document.body.classList.remove('qrscanner');
          }
        } else {
          this.toaster.errorToast('error_qrcode');
          document.body.classList.remove('qrscanner');
        }
      }
    } else {
      this.alert.alertFreeGuest();
    }
  }

  async checkPermission() {
    return new Promise(async (resolve, reject) => {
      const status = await BarcodeScanner.checkPermission({ force: true });

      if (status.granted) {
        resolve(true);
      } else if (status.denied) {
        this.toaster.infoToast(await this.translate.get('you_should_activate_scan').toPromise());
        resolve(false);
      } else {
        this.toaster.infoToast(await this.translate.get('you_should_activate_scan').toPromise());
        resolve(false);
      }
    });
  }

  stopScanner() {
    BarcodeScanner.showBackground();
    BarcodeScanner.stopScan();
  }
}
